export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Users',
    route: 'visitor-users',
    faIcon: 'fas fa-chart-pie',
  },
  {
    title: 'Calls',
    route: 'calls',
    faIcon: 'fas fa-chart-pie',
  },
]
